import React from "react";
import { Row, Col } from "antd";
import "./css/payment.css";
import dayjs from "dayjs";
import THBText from "thai-baht-text";
import imgA2 from "./pic/a2.jpg";

function NotifyGuarantor28({ dataTabelB, selectedContract, indexA, indexB, roundDate }) {
  //โหลดรูป
  const nameCus1 = dataTabelB?.SNAM + "" + dataTabelB?.NAME1 + " " + dataTabelB?.NAME2;
  const nameCus0 = dataTabelB?.BSNAM + "" + dataTabelB?.BNAME1 + " " + dataTabelB?.BNAME2;
  const datePrint = dayjs().format("DD/MM/YYYY");
  const dateSDATE = dayjs(dataTabelB?.SDATE).format("DD/MM/YYYY");
  const dateDDATE = dayjs(dataTabelB?.FirstUnpaidDate).format("DD/MM/YYYY");
  const dateRoundDate = dayjs(dataTabelB?.roundDate).format("DD/MM/YYYY");
  const CONTNO = dataTabelB.CONTNO

  let addCompany1, T1, A1, J1;
  J1 = `จ. ${dataTabelB?.PROVDES}`;
  if (selectedContract?.key === "vsfhp") {
    addCompany1 = "บริษัท วัน ลิสซิ่ง จำกัด";
  } else {
    addCompany1 = "บริษัท วัน มันนี่ จำกัด";
  }
  if (dataTabelB?.PROVCOD === "01") {
    T1 = `แขวง ${dataTabelB?.TUMB}`;
    A1 = `เขต ${dataTabelB?.AUMPDES}`;
  } else {
    T1 = `ต.${dataTabelB?.TUMB}`;
    A1 = `อ.${dataTabelB?.AUMPDES}`;
  }

  return (
    <>
      <div className="divA4">
        <div className="divEdge30">
          <Row>
            <Col span={24} style={{ textAlign: "right" }}>
              {indexA + 1}/{indexB}
            </Col>
            {/* <Col span={24} style={{ marginBottom: '40px' }}></Col> */}
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">ชื่อลูกค้า :&emsp;&nbsp;&nbsp;{nameCus1} (คนค้ำ{dataTabelB?.GARNO}) ({CONTNO})</Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">
              ที่อยู่ :&emsp;&emsp;&nbsp;&nbsp;&nbsp;เลขที่&nbsp;
              {dataTabelB?.ADDR1}
              {dataTabelB?.ADDR2}
            </Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">
              &emsp;&emsp;&emsp;&emsp;{T1}&nbsp;{A1}&nbsp;{J1}&nbsp;
              {dataTabelB?.ZIP}
            </Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">เบอร์โทร :&emsp;&nbsp;{dataTabelB?.TELP}</Col>
            <Col span={4} className="colLeft0"></Col>
            <Col span={20} className="colLeft0">&emsp;({dateRoundDate})</Col>

            <Col span={24} style={{ marginBottom: "130px" }}></Col>
            <Col span={24} className="colRight" />

            <Col span={16} className="colLeft"></Col>
            <Col span={8} className="colLeft">
              วันที่ :&emsp;{datePrint}
            </Col>
            <Col span={24} style={{ marginBottom: "10px" }}></Col>
            <Col span={24} className="colLeft">
              เรื่อง&emsp;เรื่องแจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ
              สัญญาเช่าซื้อเลขที่ ({dataTabelB?.CONTNO})
            </Col>
            <Col span={24} className="colLeft">
              เรียน&emsp;{nameCus1}
            </Col>

            <Col span={24} style={{ marginBottom: '20px' }}></Col>
            <Col span={12} className="colLeft">&emsp;ตามที่ท่านได้ตกลงทำสัญญาค้ำประกันการเช่าซื้อรถยนต์ยี่ห้อ</Col>
            <Col span={3} className="colLeft">{dataTabelB?.TYPE}</Col>
            <Col span={1} className="colLeft">รุ่น</Col>
            <Col span={4} className="colLeft">{dataTabelB?.MODEL}</Col>
            {/* <Col span={1} className="colLeft">สี</Col> */}
            {/* <Col span={3} className="colLeft">{dataTabelB?.COLOR}</Col> */}
            <Col span={4} className="colLeft">สี {dataTabelB?.COLOR}</Col>

            <Col span={3} className="colLeft">
              เลขตัวถัง
            </Col>
            <Col span={5} className="colLeft">
              {dataTabelB?.STRNO}
            </Col>
            <Col span={3} className="colLeft">
              เลขเครื่อง
            </Col>
            <Col span={5} className="colLeft">
              {dataTabelB?.ENGNO}
            </Col>
            <Col span={3} className="colLeft">
              ทะเบียน
            </Col>
            <Col span={5} className="colLeft">
              {dataTabelB?.REGNO}&nbsp;{dataTabelB?.DORECV}
            </Col>

            <Col span={11} className="colLeft">
              ระหว่าง&nbsp;{nameCus0}&nbsp;ผู้เช่าซื้อกับ
            </Col>
            {/* <Col span={8} className="colLeft">{nameCus0}&nbsp;ผู้เช่าซื้อกับ</Col> */}
            <Col span={11} className="colLeft">
              {addCompany1}
              &nbsp;ผู้ให้เช่าซื้อ&nbsp;ตามสัญญาเช่าซื้อฉบับลงวันที่
            </Col>
            {/* <Col span={7} className="colLeft">ตามสัญญาเช่าซื้อฉบับลงวันที่</Col> */}
            <Col span={2} className="colLeft">
              {dateSDATE}
            </Col>

            <Col span={24} className="colLeft">
              รายละเอียดที่ท่านทราบดีอยู่แล้วนั้น
              บัดนี้ผู้เช่าซื้อได้ปฏิบัติผิดสัญญา โดยค้างชำระค่าเช่าซื้อ งวดที่{" "}
              {dataTabelB?.EXP_FRM}-{dataTabelB?.EXP_TO} ซึ่งกำหนดชำระ{" "}
              {dateDDATE} จำนวน
            </Col>

            <Col span={6} className="colLeft">
              {dataTabelB?.EXP_PRD} งวดติดต่อกันเป็นจำนวนเงิน
            </Col>
            {/* <Col span={4} className="colCenter">{(dataTabelB?.EXP_AMT ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Col> */}
            <Col span={4} className="colCenter">
              {Number(dataTabelB?.EXP_AMT ?? 0).toLocaleString("th-TH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Col>
            <Col span={2} className="colLeft">
              บาท
            </Col>
            <Col span={8} className="colCenter">
              {THBText(dataTabelB?.EXP_AMT)}
            </Col>
            <Col span={4} className="colLeft">
              (รวมภาษีมูลค่าเพิ่ม)
            </Col>

            <Col span={24} className="colLeft">
              ส่วนค่าเบี้ยปรับตามกฎหมาย พร้อมค่าใช้จ่ายในการติดตามและอื่น ๆ
              ขอให้ท่านชำระหนี้ที่ค้างทั้งหมด
            </Col>

            <Col span={4} className="colLeft">
              ให้แล้วเสร็จภายใน
            </Col>
            <Col span={1} className="colLeft">
              7
            </Col>
            <Col span={1} className="colLeft">
              วัน
            </Col>
            <Col span={18} className="colLeft">
              นับแต่วันที่ท่านได้รับหนังสือฉบับนี้
            </Col>

            <Col span={24} style={{ marginBottom: "20px" }}></Col>
            <Col span={24} className="colLeft">
              &emsp;หากท่านเพิกเฉยระยะเวลาตามหนังสือ
              ท่านไม่ชำระหนี้ผู้ให้เช่าซื้อมีความจำเป็นที่จะต้อง
              ดำเนินการตามกฎหมายต่อไป
            </Col>
            <Col span={24} className="colLeft">
              &emsp;&emsp;จึงเรียนมาเพื่อโปรดดำเนินการด่วน
            </Col>

            <Col span={24} style={{ marginBottom: '60px' }}></Col>
              <Col span={18} className="colLeft"></Col>
            <Col span={6} className="colCenter"><img src={imgA2} alt="example" style={{ height: '36px' }} /></Col>
            <Col span={18} className="colLeft"></Col>
            <Col span={6} className="colCenter">
              ลงชื่อ.................................
            </Col>

            <Col span={24} style={{ marginBottom: "40px" }}></Col>
            <Col span={18} className="colLeft"></Col>
            <Col span={6} className="colCenter">
              ผู้ออกจดหมาย
            </Col>

            <Col span={24} style={{ marginBottom: "40px" }}></Col>
            <Col span={24} className="colLeft">
              - หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้
              ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
export default NotifyGuarantor28;
